export default {"src":"/_next/static/media/search.94908992.svg","height":14,"width":14};